import React from 'react';
import { Helmet } from 'react-helmet-async';

const Seo = ({
  title,
  description = 'أرشيف رقمي لتوثيق سيرة الشهداء وإحياء ذكراهم بالكتابات والقصائد والصور والفيديو.',
  image = '/default.png'
}) => {
  const fullTitle = title ? `${title} | أرشيف الشهداء` : 'أرشيف الشهداء — متحف رقمي للذكرى';

  return (
    <Helmet>
      <html lang="ar" dir="rtl" />
      <title>{fullTitle}</title>
      <link rel="icon" href="/favicon.ico" sizes="any" />
      <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
      <meta name="description" content={description} />
      <meta name="theme-color" content="#14532d" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default Seo;
